import React from 'react';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '1',
    title: 'Checklists Listos para Usar',
    desc: '+40 checklists profesionales de inspección de máquinas: rutinas diarias, semanales y mensuales con formatos listos para imprimir y entregar al alumno.',
    value: '$12.000'
  }, {
    num: '2',
    title: '50 Casos Reales de Fallas',
    desc: '50 situaciones reales de fallas industriales con análisis de síntomas, diagnóstico paso a paso y resolución técnica documentada.',
    value: '$8.500'
  }, {
    num: '3',
    title: 'Actividades Prácticas para el Taller',
    desc: 'Ejercicios de diagnóstico, simulación de fallas, actividades de inspección y trabajos grupales con guía docente incluida para cada uno.',
    value: '$9.500'
  }, {
    num: '4',
    title: 'Planes de Mantenimiento Editables',
    desc: 'Plantillas de planes de mantenimiento completos en formato editable: Word y Excel listos para personalizar, con ejemplos resueltos y guía de uso en el aula.',
    value: '$6.000'
  }];
  return <section className="py-8 md:py-12 px-3 bg-brand-bordo" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <div className="text-center mb-8" data-id="element-20">
          <h2 className="text-2xl md:text-4xl font-black text-white uppercase text-shadow-lg" data-id="element-21">
            🎁 4 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-base md:text-xl text-brand-accent font-black mt-2 neon-glow uppercase" data-id="element-22">
            Todo lo que completa tu arsenal docente. Gratis con tu Kit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-23">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-card rounded-xl p-5 border-2 border-white/10 hover:border-brand-accent transition-colors relative overflow-hidden group shadow-xl" data-id="element-24">
              <div className="absolute -right-6 -top-6 w-24 h-24 bg-brand-accent/10 rounded-full group-hover:scale-150 transition-transform duration-500" data-id="element-25"></div>

              <div className="flex items-start mb-3 relative z-10" data-id="element-26">
                <div className="bg-brand-accent text-black font-black text-xl w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0 shadow-[0_2px_0_#CA8A04]" data-id="element-27">
                  {bonus.num}
                </div>
                <div data-id="element-28">
                  <div className="flex items-center gap-1 mb-1" data-id="element-29">
                    <Gift className="w-4 h-4 text-brand-accent" data-id="element-30" />
                    <span className="text-brand-accent font-black text-xs tracking-widest uppercase" data-id="element-31">
                      BONO {bonus.num}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-black leading-tight text-white uppercase" data-id="element-32">
                    {bonus.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm text-gray-300 relative z-10 mb-4 leading-relaxed font-medium" data-id="element-33">
                {bonus.desc}
              </p>

              <div className="bg-black p-3 rounded-lg border border-white/10 relative z-10 text-center" data-id="element-34">
                <p className="text-xs text-gray-400 font-bold uppercase" data-id="element-35">
                  Valor real:{' '}
                  <span className="line-through" data-id="element-36">{bonus.value} ARS</span> —{' '}
                  <span className="text-brand-accent font-black text-sm neon-glow" data-id="element-37">
                    HOY GRATIS
                  </span>
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-card rounded-xl p-4 text-center border-4 border-brand-accent max-w-xl mx-auto shadow-[0_0_30px_rgba(234,179,8,0.2)]" data-id="element-38">
          <p className="text-lg md:text-xl font-bold text-gray-300 uppercase" data-id="element-39">
            💰 Valor total de bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-40">$36.000 ARS</span>
            <br data-id="element-41" />
            <span className="text-brand-accent font-black neon-glow text-2xl md:text-3xl block mt-2" data-id="element-42">
              👉 HOY GRATIS con tu Kit
            </span>
          </p>
        </div>
      </div>
    </section>;
}